import { useSelector } from 'react-redux'
import { useMemo } from 'react'
import { RootState } from '../redux'
import { DateRange } from '../types'

export default function useQuery() {
  return useSelector((state: RootState) => state.query)
}

export function useDateRangeQuery(): DateRange {
  const { from, to } = useSelector((state: RootState) => state.query)

  return useMemo(() => {
    return { from, to }
  }, [from, to])
}
